var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-table',{staticClass:"affiliate-table",attrs:{"url":"/api/v1/affiliate","appends":['soi_and_doi_today', 'soi_and_doi_total'],"attributes":[
    {
      attribute: 'id',
      name: 'ID'
    },
    {
      attribute: 'created_at',
      name: 'Erstellt am',
      type: 'DateCell'
    },
    {
      attribute: 'description',
      name: 'Beschreibung',
      customStyle: 'max-width: 300px;'
    },
    {
      attribute: 'partner',
      name: 'Werbepartner'
    },
    {
      attribute: 'quota',
      name: 'Kontingent'
    },
    {
      attribute: 'one_click_passing',
      name: '1CP',
      type: 'CheckMarkerCell'
    },
    {
      attribute: 'cpm',
      name: 'TKP',
      type: 'CurrencyCell'
    },
    {
      attribute: 'cpl',
      name: 'CPL',
      type: 'CurrencyCell',
      sortable: false
    },
    {
      attribute: 'soi_and_doi_today',
      name: _vm.iconNewVerifiedCustomersToday,
      html: true,
      tooltip: 'Mitglieder Heute / SOI und DOI',
      sortable: false
    },
    {
      attribute: 'soi_and_doi_total',
      name: _vm.iconNewVerifiedCustomersTotal,
      html: true,
      tooltip: 'Mitglieder Gesamt / SOI und DOI',
      sortable: false
    },
    {
      attribute: 'page_visits',
      name: _vm.iconPageVisits,
      html: true,
      tooltip: 'Seitenaufrufe Heute / Gesamt',
      sortable: false
    },
    {
      attribute: 'today_revenue',
      name: _vm.iconIncomeToday,
      html: true,
      type: 'CurrencyCell',
      tooltip: 'Einnahmen Heute',
      sortable: false
    },
    {
      attribute: 'total_revenue',
      name: _vm.iconIncomeTotal,
      html: true,
      type: 'ModalCell',
      modal: 'AffiliateUserRevenueModal',
      mode: 'userCurrency',
      tooltip: 'Einnahmen Total',
      sortable: false
    },
    {
      name: 'Aktionen',
      type: 'AffiliateActionCell'
    }
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }